import { TabNames } from '@/pages-v2/home/storeList/component/StoreTabs/constants'
import VueI18n from '@/i18n/locale'
import { getList } from './service'

// 排除的参数
export const exceptFilterKey = {
  [TabNames.priority.key]: ['notMyStore'],
  [TabNames.my.key]: ['notMyStore'],
  [TabNames.all.key]: ['notMyStore']
}

export const requestTypeMap = {
  [TabNames.priority.key]: 2,
  [TabNames.area.key]: 3,
  [TabNames.my.key]: 4,
  [TabNames.all.key]: 1
}

export const requesterMap = {
  [TabNames.priority.key]: getList,
  [TabNames.area.key]: getList,
  [TabNames.my.key]: getList,
  [TabNames.all.key]: getList
}
export const cityOptionsMap = {
  [TabNames.priority.key]: 'cityIds',
  [TabNames.area.key]: 'cityIds',
  [TabNames.my.key]: 'cityIds',
  [TabNames.all.key]: 'cityIds'
}

export const cityValuesMap = {
  [TabNames.priority.key]: ['cityId', 'countyIds'],
  [TabNames.area.key]: ['cityId', 'countyIds'],
  [TabNames.my.key]: ['cityId', 'countyIds'],
  [TabNames.all.key]: ['cityId', 'countyIds']
}

export const CityAndAreaKeyMap = {
  cityId: 'cityId',
  AreaCityId: 'cityId',
  countyIds: 'countyIds',
  AreaAreaIds: 'countyIds'
}

export const sortTypeEnum = [
  {
    value: 0,
    label: `${VueI18n.t('FoodB_202207_Default_BQmA' /** 默认 */)} (${VueI18n.t(
      'Internal_Tools_App_xBYh_JJGr' /** 距离 */
    )})`
  }
]
